module.exports = __webpack_public_path__ + "img/WE-ABLE-Comp.e1341648.png";